import { matchPath } from 'react-router';

import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

import { useHomeAccess } from './useHomeAccess';

/**
 * Whether the new Home page is genuinely active right now — the Home flag is
 * on and the current route resolves to it (`/` redirects here when eligible,
 * `/home` is the surface itself). Home-only behavior (e.g. opening Ask AI
 * expanded) should gate on this rather than assuming a component only ever
 * renders from Home, since that assumption breaks silently if the component
 * is ever reused elsewhere.
 */
export const useIsHomePageActive = () => {
  const { canUseHome: hasHomePage } = useHomeAccess();
  const { location } = useRouting();

  return (
    hasHomePage &&
    Boolean(
      matchPath(RoutePathType.Home, location.pathname) ||
      matchPath(RoutePathType.HomeSurface, location.pathname),
    )
  );
};
